import axios from "axios";

import store from "../store";

export const api = axios.create({
    baseURL: process.env.VUE_APP_API_BASE
});

axios.defaults.headers.post["Content-Type"] =
    "application/x-www-form-urlencoded";

// TODO: figure out why themeConfig.apiBaseURL is not being picked up
// could look into env variable
// worst case scenario grab this value directly from themeConfig and not the store

export const getApiClient = () =>
    axios.create({
        baseURL: store.getters.apiBaseURL,
        withCredentials: false,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    });

export default {
    getServerTime() {
        const token = store.state.userCredentials.idToken;
        return getApiClient().get(`/server-time`, {
            headers: {
                Authorization: `bearer ${token}`
            }
        });
    },
    getAttendeeSchedule() {
        const token = store.state.userCredentials.idToken;
        return getApiClient().get(`/schedule`, {
            headers: {
                Authorization: `bearer ${token}`
            }
        });
    },
    getCompany(companyId: string) {
        const token = store.state.userCredentials.idToken;
        return getApiClient().get(`/companies/${companyId}`, {
            headers: {
                Authorization: `bearer ${token}`
            }
        });
    },
    getFeaturedAttendees(tableName = "") {
        const token = store.state.userCredentials.idToken;
        if (tableName) {
            return getApiClient().get(
                `/featuredattendees?tableName=${tableName}`,
                {
                    headers: {
                        Authorization: `bearer ${token}`
                    }
                }
            );
        } else {
            return getApiClient().get(`/featuredattendees`, {
                headers: {
                    Authorization: `bearer ${token}`
                }
            });
        }
    },
    getFeaturedAttendeeByType(attendeeType: boolean) {
        const token = store.state.userCredentials.idToken;
        return getApiClient().get(
            `/featuredattendees?grouped=${attendeeType}`,
            {
                headers: {
                    Authorization: `bearer ${token}`
                }
            }
        );
    },
    getAttendeeSearchResults(searchString: string) {
        const token = store.state.userCredentials.idToken;
        return getApiClient().post(
            "/search",
            { searchString },
            {
                headers: {
                    Authorization: `bearer ${token}`
                }
            }
        );
    },
    getTradeshowCompany(companyId: string, tableName = "") {
        const token = store.state.userCredentials.idToken;
        if (tableName) {
            return getApiClient().get(
                `/tradeshow/${companyId}?tableName=${tableName}`,
                {
                    headers: {
                        Authorization: `bearer ${token}`
                    }
                }
            );
        } else {
            return getApiClient().get(`/tradeshow/${companyId}`, {
                headers: {
                    Authorization: `bearer ${token}`
                }
            });
        }
    },
    getTradeshowCompanies(tableName = "") {
        const token = store.state.userCredentials.idToken;
        if (tableName) {
            return getApiClient().get(`/tradeshow?tableName=${tableName}`, {
                headers: {
                    Authorization: `bearer ${token}`
                }
            });
        } else {
            return getApiClient().get(`/tradeshow`, {
                headers: {
                    Authorization: `bearer ${token}`
                }
            });
        }
    },
    getSession(insightId: string, tableName = "") {
        const token = store.state.userCredentials.idToken;
        if (tableName) {
            return getApiClient().get(
                `/sessions/${insightId}?tableName=${tableName}`,
                {
                    headers: {
                        Authorization: `bearer ${token}`
                    }
                }
            );
        } else {
            return getApiClient().get(`/sessions/${insightId}`, {
                headers: {
                    Authorization: `bearer ${token}`
                }
            });
        }
    },
    getSessions(tableName = "") {
        const token = store.state.userCredentials.idToken;
        if (tableName) {
            return getApiClient().get(`/sessions?tableName=${tableName}`, {
                headers: {
                    Authorization: `bearer ${token}`
                }
            });
        } else {
            return getApiClient().get(`/sessions`, {
                headers: {
                    Authorization: `bearer ${token}`
                }
            });
        }
    },
    appendLogEntry(logEntry: object) {
        const token = store.state.userCredentials.idToken;
        return getApiClient().post(`/log/append`, logEntry, {
            headers: {
                Authorization: `bearer ${token}`
            }
        });
    },
    getMeetingRoom(appointmentId: string) {
        const token = store.state.userCredentials.idToken;
        return getApiClient().get(`/appointments/${appointmentId}`, {
            headers: {
                Authorization: `bearer ${token}`
            }
        });
    },
    getVideoComments(insightId: string, after = "") {
        // 'after' is an iso string representing a point of time of earliest comments to get
        const token = store.state.userCredentials.idToken;
        return getApiClient().get(`/comments/${insightId}?after=${after}`, {
            headers: {
                Authorization: `bearer ${token}`
            }
        });
    },
    getFeaturedVideo() {
        const token = store.state.userCredentials.idToken;
        return getApiClient().get("/featured-video", {
            headers: {
                Authorization: `bearer ${token}`
            }
        });
    },
    postVideoComment(insightId: string, text: string) {
        const token = store.state.userCredentials.idToken;
        return getApiClient().post(
            `/comments/${insightId}`,
            { text },
            {
                headers: {
                    Authorization: `bearer ${token}`
                }
            }
        );
    },
    createUrl(url: string, starts: number, expires: number) {
        const token = store.state.userCredentials.idToken;
        return getApiClient().post(
            "/video/url",
            {
                url,
                starts,
                expires
            },
            {
                headers: {
                    Authorization: `bearer ${token}`
                }
            }
        );
    },
    createCookies(url: string, starts: number, expires: number) {
        const token = store.state.userCredentials.idToken;
        return getApiClient().post(
            "/video/cookies",
            {
                url,
                starts,
                expires
            },
            {
                headers: {
                    Authorization: `bearer ${token}`
                }
            }
        );
    }
};
